module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/sniffspot-app-ss-281.7210f7f0b95ea8e3.png"+" 281w",
        images: [{path: "https://static.sniffspot.com/packs/img/sniffspot-app-ss-281.7210f7f0b95ea8e3.png",width: 281,height: 569}],
        src: "https://static.sniffspot.com/packs/img/sniffspot-app-ss-281.7210f7f0b95ea8e3.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/sniffspot-app-ss-281.7210f7f0b95ea8e3.png"},
        
        width: 281,
        height: 569
      }